/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Decision_DeskInputs */

const en_directory_detail_decision_desk = /** @type {(inputs: Directory_Detail_Decision_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decision desk`)
};

const zh_directory_detail_decision_desk = /** @type {(inputs: Directory_Detail_Decision_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`决策核对台`)
};

/**
* | output |
* | --- |
* | "Decision desk" |
*
* @param {Directory_Detail_Decision_DeskInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_decision_desk = /** @type {((inputs?: Directory_Detail_Decision_DeskInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Decision_DeskInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_decision_desk(inputs)
	return zh_directory_detail_decision_desk(inputs)
});
export { directory_detail_decision_desk as "directory.detail.decision_desk" }